<template>
  <article>
    <Feature :title="'功能權限維護'" :iconClass="'fa-user-circle-o'">
   
    </Feature>
  </article>
</template>

<script>
import { mapGetters } from 'vuex';
import { mapActions } from 'vuex';

export default {
  name: "AccountMaintain",
  components: {
  },
  data() {
    return {

    }
  },
  created() {
    
  },
  methods: {
    ...mapGetters([
    ]),
    ...mapActions([
      'toggleLoading'
    ]),
  },
  mounted() {
    /* this.$http
      .get(`/test`)
      .then(response => {})
      .catch(() => {}) */
  },
}
</script>

<style scoped>

</style>
